export const GET_MY_LOCATION = 'GET_MY_LOCATION';
export const STORE_ALL_NEW_LOCATION = 'STORE_ALL_NEW_LOCATION';
